<template>
  <section class="hero is-success is-fullheight">
    <div class="hero-body">
      <div class="container has-text-centered">
        <div class="column is-4 is-offset-4">
          <h3 class="title has-text-grey">Login</h3>
          <p class="subtitle has-text-grey">Please login to proceed.</p>
          <div class="box">
            <form @submit.prevent="login">
              <div class="field">
                <div class="control">
                  <input class="input is-large" type="email" placeholder="Your Email" autofocus="" v-model="email">
                </div>
              </div>
  
              <div class="field">
                <div class="control">
                  <input class="input is-large" type="password" placeholder="Your Password" v-model="password">
                </div>
              </div>
              <div class="field">
  
              </div>
              <button class="button is-block is-info is-large is-fullwidth" :class="isLoading">Login</button>
            </form>
          </div>
  
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import Auth from '../libraries/auth.js'
  
  
  
  export default {
    data () {
      return {
        email: '',
        password: '',
        error: false,
        isLoading: ""
      }
    },
    methods: {
      login () {
        this.isLoading = "is-loading";
        Auth.login(this.email, this.password, loggedIn => {
          this.isLoading = "";
          if (!loggedIn) {
            this.error = true
          } else {
            let reply = this.permisisonRefresh();
            reply.then((res) => {
              this.$router.push('/');
            });
          }
        })
      }
    },
    created () {
      if(Auth.loggedIn()){
        this.$router.push('/');
      }
    }

  }
</script>

<style lang="scss" scoped>
  .hero.is-success {
    background: #F2F6FA;
  }
  
  .hero .nav,
  .hero.is-success .nav {
    -webkit-box-shadow: none;
    box-shadow: none;
  }
  
  .box {
    margin-top: 5rem;
  }
  
  .avatar {
    margin-top: -70px;
    padding-bottom: 20px;
  }
  
  .avatar img {
    padding: 5px;
    background: #fff;
    border-radius: 50%;
    -webkit-box-shadow: 0 2px 3px rgba(10, 10, 10, .1), 0 0 0 1px rgba(10, 10, 10, .1);
    box-shadow: 0 2px 3px rgba(10, 10, 10, .1), 0 0 0 1px rgba(10, 10, 10, .1);
  }
  
  input {
    font-weight: 300;
  }
  
  p {
    font-weight: 700;
  }
  
  p.subtitle {
    padding-top: 1rem;
  }
</style>




// WEBPACK FOOTER //
// src/pages/login.vue